// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".translation-header[data-v-493c5199] {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n}\n.translation-header .translation-button[data-v-493c5199] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
